import s from "./style.module.css";

<text-stack align="left" class=s.text>
    <@body>
        Our design system, Evo, impacts every touchpoint of the eBay experience
        around the world. The eBay Playbook ensures we execute with intention
        and humanity.
    </@body>
    <@cta
        href="https://playbook.ebay.com/"
        priority="secondary"
        target="_blank">
        <@icon>
            <icon-external-link-20/>
        </@icon>
        eBay Playbook
    </@cta>
</text-stack>
